import React, { useEffect } from 'react';
import { useTenant } from '../contexts/TenantContext';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';
import { Box, Button, Typography, List, ListItem, ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import WarningIcon from '@mui/icons-material/Warning';

const TenantSaS = () => {
  const { fetchTenantsFromApi, switchTenant } = useTenant();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [tenants, setTenants] = React.useState([]);

  useEffect(() => {
    if (!isAuthenticated()) {
      console.log("[DEBUG] User not authenticated. Redirecting to /login.");
      navigate('/login', { replace: true }); // Use replace to avoid adding to history
      return;
    }

    const fetchTenants = async () => {
      try {
        const tenantsList = await fetchTenantsFromApi();
        setTenants(tenantsList);

        console.log("[DEBUG] Fetched tenants:", tenantsList);

        // Redirect to tenant dashboard if only one tenant exists
        if (tenantsList.length === 1) {
          const singleTenant = tenantsList[0];
          console.log("[DEBUG] Single tenant found. Redirecting to dashboard:", singleTenant);
          switchTenant(singleTenant.tenant_id);
          navigate(`/app/${singleTenant.subdomain_prefix}/dashboard`);
        }
      } catch (error) {
        console.error('[DEBUG] Error fetching tenants:', error);
      }
    };

    fetchTenants();

    // Log browser history for debugging
    console.log("[DEBUG] Browser history state:", window.history);
  }, [fetchTenantsFromApi, navigate]);

  const handleNavigate = (subdomain, tenant_id) => {
    switchTenant(tenant_id);
    navigate(`/app/${subdomain}/dashboard`);
  };

  return (
    <>
        {/* <Header title={t('dashboard.headerTitle')} /> */}
        <Box 
            
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start', // Align content to the top
                minHeight: '100vh',
                backgroundColor: '#f0f2f5', // Optional: background color for the page
                paddingTop: '20px' // Add some padding to the top
        }}>
            {/* If no tenants are available */}
            {tenants.length === 0 && (
                <>
                    <WarningIcon sx={{ color: 'red' }} />
                    <Typography variant="h6" color="textSecondary">
                        {t('tenantSas.noTenants')}
                    </Typography>
                </>
            )}

            {/* If tenants are available, show the list */}
            {tenants.length > 0 && (
                <>
                    <Typography variant="h4" gutterBottom>
                        {t('tenantSas.allowedTenants')}
                    </Typography>
                    <nav aria-label="main mailbox folders">
                        <List>
                            {tenants.map((tenant) => (
                            <ListItem 
                                key={tenant.tenant_id} 
                                sx={{ display: 'flex', alignItems: 'center', paddingLeft: 0 }} // Ensure alignment and remove extra padding
                                onClick={() => handleNavigate(tenant.subdomain_prefix, tenant.tenant_id)}
                            >
                                <ListItemButton sx={{ paddingLeft: 0 }}> {/* Remove padding from the button */}
                                    <ListItemIcon sx={{ minWidth: '40px' }}> {/* Adjust icon spacing */}
                                        <CorporateFareIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={`${t('tenantSas.goToDashboard')} ${tenant.name}`} />
                                </ListItemButton>
                            </ListItem>
                            ))}
                        </List>
                    </nav>
                </>
            )}
        </Box>
    </>
  );
};

export default TenantSaS;